import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useState } from 'react'
import Modal from '../common/Modal'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'

interface Member {
  id: number
  name: string
  kana: string | null
  email: string
  code: string | null
  profile_image: string | null
  team_name: string
  cost_view: boolean
  member_cost_setting: boolean
  project_cost_setting: boolean
  project_setting: boolean
  attendance_export: boolean
  project_member_setting: boolean
}

interface Props {
  targetMemberList: Member[]
  closeCallback: VoidFunction
  modCallback: (
    memberIds: number[],
    projectSetting: boolean,
    costView: boolean,
    memberCostSetting: boolean,
    projectCostSetting: boolean,
    attendanceExport: boolean,
    projectMemberSetting: boolean,
  ) => void
  isDisplay: boolean
}

const DISPLAY_MODAL_MEMBER_LIMIT = 30

const AdminModal: FC<Props> = (props) => {
  const {
    targetMemberList,
    closeCallback,
    modCallback,
    isDisplay,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const [projectSetting, setProjectSetting] = useState<boolean>(false)
  const [costView, setCostView] = useState<boolean>(false)
  const [memberCostSetting, setMemberCostSetting] = useState<boolean>(false)
  const [projectCostSetting, setProjectCostSetting] = useState<boolean>(false)
  const [attendanceExport, setAttendanceExport] = useState<boolean>(false)
  const [projectMemberSetting, setProjectMemberSetting] = useState<boolean>(false)

  const resetParam = () => {
    setProjectSetting(false)
    setCostView(false)
    setMemberCostSetting(false)
    setProjectCostSetting(false)
    setAttendanceExport(false)
    setProjectMemberSetting(false)
  }

  const closeModal = () => {
    closeCallback()
    resetParam()
  }

  const submitAdmin = () => {
    modCallback(
      targetMemberList.map((v) => v.id),
      projectSetting,
      costView,
      memberCostSetting,
      projectCostSetting,
      attendanceExport,
      projectMemberSetting,
    )
    resetParam()
  }

  useEffect(() => {
    const targetSample = targetMemberList[0]
    setProjectSetting(targetSample?.project_setting || false)
    setCostView(targetSample?.cost_view || false)
    setMemberCostSetting(targetSample?.member_cost_setting || false)
    setProjectCostSetting(targetSample?.project_cost_setting || false)
    setAttendanceExport(targetSample?.attendance_export || false)
    setProjectMemberSetting(targetSample?.project_member_setting || false)
  }, [isDisplay])

  return (
    <Modal
      title="権限の編集"
      show={isDisplay}
      wrapperClass="task_administrator_modal"
      closeCallback={closeModal}
      closeable
    >
      <>
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            gap: "16px",
          }}
        >
          <div
            style={{
              border: "solid 1px #999999",
              borderRadius: "4px",
              padding: "8px",
              display: "flex",
              flexFlow: "column",
              gap: "8px",
              backgroundColor: "#F3F3f3",
            }}
          >
            <div>
              対象
            </div>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "4px",
              }}
            >
              {
                targetMemberList.slice(0, DISPLAY_MODAL_MEMBER_LIMIT).map((v) => (
                  <div
                    key={`member_${v.id}`}
                    style={{
                      border: "solid 1px #999999",
                      borderRadius: "20px",
                      padding: "2px 8px",
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      fontSize: "10px",
                      backgroundColor: "#FFFFFF",
                    }}
                  >
                    <img
                      alt={v.name}
                      src={v.profile_image ?? `/static/images/profile/${(Number(v.id) || 0) % 12}.jpeg`}
                      style={{ width: "16px", height: "16px", borderRadius: "50%" }}
                    />
                    {v.name}
                  </div>
                ))
              }
              {
                targetMemberList.length > DISPLAY_MODAL_MEMBER_LIMIT && (
                  <div
                    style={{
                      padding: "3px",
                    }}
                  >
                    {`…他${targetMemberList.length - DISPLAY_MODAL_MEMBER_LIMIT}名`}
                  </div>
                )
              }
            </div>
          </div>
          <div className="item">
            <div className="title">
              権限
            </div>
            <div className="detail row_1">
              <div
                className="checkbox_area"
                style={{
                  backgroundColor: projectSetting ? "#d9ffdd" : "#FFFFFF",
                }}
                onClick={() => setProjectSetting(!projectSetting)}
                role="none"
              >
                <div
                  className="checkbox"
                  style={{
                    color: projectSetting ? "#08984C" : "#666666",
                  }}
                >
                  <FontAwesomeIcon icon={['far', projectSetting ? 'check-square' : 'square']} />
                </div>
                <div>
                  <div className="checkbox_area_title">
                    プロジェクト・カテゴリー設定
                  </div>
                  <div className="checkbox_area_description">
                    プロジェクト・カテゴリーを設定・編集することができます
                  </div>
                </div>
              </div>
              <div
                className="checkbox_area"
                style={{
                  backgroundColor: costView ? "#d9ffdd" : "#FFFFFF",
                }}
                onClick={() => setCostView(!costView)}
                role="none"
              >
                <div
                  className="checkbox"
                  style={{
                    color: costView ? "#08984C" : "#666666",
                  }}
                >
                  <FontAwesomeIcon icon={['far', costView ? 'check-square' : 'square']} />
                </div>
                <div>
                  <div className="checkbox_area_title">
                    コスト表示
                  </div>
                  <div className="checkbox_area_description">
                    プロジェクトにかかったコストを表示することができます
                  </div>
                </div>
              </div>
              <div
                className="checkbox_area"
                style={{
                  backgroundColor: memberCostSetting ? "#d9ffdd" : "#FFFFFF",
                }}
                onClick={() => setMemberCostSetting(!memberCostSetting)}
                role="none"
              >
                <div
                  className="checkbox"
                  style={{
                    color: memberCostSetting ? "#08984C" : "#666666",
                  }}
                >
                  <FontAwesomeIcon icon={['far', memberCostSetting ? 'check-square' : 'square']} />
                </div>
                <div>
                  <div className="checkbox_area_title">
                    ユーザーコスト設定
                  </div>
                  <div className="checkbox_area_description">
                    ユーザーのコストを設定することができます
                  </div>
                </div>
              </div>
              <div
                className="checkbox_area"
                style={{
                  backgroundColor: projectCostSetting ? "#d9ffdd" : "#FFFFFF",
                }}
                onClick={() => setProjectCostSetting(!projectCostSetting)}
                role="none"
              >
                <div
                  className="checkbox"
                  style={{
                    color: projectCostSetting ? "#08984C" : "#666666",
                  }}
                >
                  <FontAwesomeIcon icon={['far', projectCostSetting ? 'check-square' : 'square']} />
                </div>
                <div>
                  <div className="checkbox_area_title">
                    プロジェクトコスト設定
                  </div>
                  <div className="checkbox_area_description">
                    プロジェクトのコストを設定することができます
                  </div>
                </div>
              </div>
              {
                login.function_enabled_state?.task_management_approval && (
                  <div
                    className="checkbox_area"
                    style={{
                      backgroundColor: attendanceExport ? "#d9ffdd" : "#FFFFFF",
                    }}
                    onClick={() => setAttendanceExport(!attendanceExport)}
                    role="none"
                  >
                    <div
                      className="checkbox"
                      style={{
                        color: attendanceExport ? "#08984C" : "#666666",
                      }}
                    >
                      <FontAwesomeIcon icon={['far', attendanceExport ? 'check-square' : 'square']} />
                    </div>
                    <div>
                      <div className="checkbox_area_title">
                        勤怠データエクスポート
                      </div>
                      <div className="checkbox_area_description">
                        勤怠データをCSV出力することができます
                      </div>
                    </div>
                  </div>
                )
              }
              {
                login.feature_config?.enable_project_member_setting && (
                  <div
                    className="checkbox_area"
                    style={{
                      backgroundColor: projectMemberSetting ? "#d9ffdd" : "#FFFFFF",
                    }}
                    onClick={() => setProjectMemberSetting(!projectMemberSetting)}
                    role="none"
                  >
                    <div
                      className="checkbox"
                      style={{
                        color: projectMemberSetting ? "#08984C" : "#666666",
                      }}
                    >
                      <FontAwesomeIcon icon={['far', projectMemberSetting ? 'check-square' : 'square']} />
                    </div>
                    <div>
                      <div className="checkbox_area_title">
                        プロジェクト参加ユーザー設定
                      </div>
                      <div className="checkbox_area_description">
                        プロジェクトの参加ユーザーを設定することができます
                      </div>
                    </div>
                  </div>
                )
              }
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "16px",
              marginTop: "32px",
            }}
          >
            <button
              type="button"
              style={{
                border: `solid 1px #999999`,
                borderRadius: "4px",
                backgroundColor: "#EEEEEE",
                color: "#666666",
                minWidth: "130px",
                textAlign: "center",
              }}
              onClick={closeModal}
            >
              キャンセル
            </button>
            <button
              type="button"
              style={{
                border: `solid 1px #507DC0`,
                borderRadius: "4px",
                backgroundColor: "#507DC0",
                color: "#FFFFFF",
                minWidth: "130px",
                textAlign: "center",
              }}
              onClick={submitAdmin}
            >
              変更する
            </button>
          </div>
        </div>
      </>
    </Modal>
  )
}

export default AdminModal
